export const INITIAL_QUERY_STATE_CONFIG = {
  variables: {},
  notifyOnNetworkStatusChange: true,
};
